import QrCode2Icon from '@mui/icons-material/QrCode2';
import ShareIcon from '@mui/icons-material/Share';
import { React, useEffect, useState, useRef, useContext } from 'react';
import { CustomerContext } from './CustomerContext';
import Flyer from './Flyer';

export default function CharityMarketing() {
    const customerContext = useContext(CustomerContext);

    function getActiveOrg() {
        if (customerContext == null) {
            return null;
        }
        if (customerContext.customer == null) {
            return null;
        }
        if (customerContext.customer.Donation_Configurations == null) {
            return null;
        }

        for (let i = 0; i < customerContext.customer.Donation_Configurations.length; i++) {
            if (customerContext.customer.Donation_Configurations[i].Status == 'Active') {
                return customerContext.customer.Donation_Configurations[i];
            }
        }

        return null;
    }

    let activeCharity = getActiveOrg();

    return (
        <div componentname='CharityMarketing' style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            {activeCharity == null ?
                <div>No active Fundraisers/Charity</div>
                :
                <>
                    <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center', textAlign: 'left' }}>
                        <QrCode2Icon sx={{ color: 'var(--sipzee-gray)', position: 'relative', top: '5px' }} /> Below you can find flyers customized to you. If a customer scans the QR code, they will be able to request to donate to you.
                    </div>

                    <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center', textAlign: 'left' }}>
                        <ShareIcon sx={{ color: 'var(--sipzee-yellow)', position: 'relative', top: '5px' }} /> You can download digitial versions to share electronically or print them yourself.
                    </div>

                    <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center' }}>
                        <Flyer flyerName={activeCharity.CompanyType + 'Flyer1'} hasImages={activeCharity.Images.length > 0} tag={activeCharity.Tag} displayName='Flyer' />
                    </div>

                    <div style={{ marginTop: '15px', maxWidth: '350px', alignSelf: 'center' }}>
                        <Flyer flyerName={'QRCode'} tag={activeCharity.Tag} displayName='QR Code only' />
                    </div>
                </>
            }
        </div>)
}